import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import mapsActions from '../../../actions/maps.actions';
import sensorsActions from '../../../actions/sensors.actions';
import helper from '../../../utils/helper';
import Loading from '../../Helpers/Loading';
import Backend from '../../Layouts/Backend';
import MapViewerPage from '../MapViewer/MapViewerPage';
import Unprivileged from '../Unprivileged';
import { isEqual } from 'lodash';
import qs from 'qs';
import moment from 'moment';

function getCurrentTime() {
  return moment().format('MM/DD/yyyy HH:mm:ss');
}

class GroupMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      didMount: false,
      isInvalid: false,
      mapImage: '',
      mapShapes: {},
      alarmStatus: [],
      alarmStatusByGroup: [],
      loading: false,
      errors: '',
      lastUpdated: getCurrentTime(),
      deptId: null,
      mapName: '',
    };
    this.refreshRate = helper.getSetting('ValueRefreshRateSec');
    this.timeStart = moment();
    this.timeOutMin = helper.getSetting('SessionTimeoutMinutes').value;
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.maps.mapImage !== prevState.mapImage) {
      state.mapImage = nextProps.maps.mapImage;
    }
    if (nextProps.maps.mapShapes !== prevState.mapShapes) {
      state.mapShapes = nextProps.maps.mapShapes;
    }
    if (nextProps.sensors.alarmStatus !== prevState.alarmStatus) {
      state.alarmStatus = nextProps.sensors.alarmStatus;
    }
    if (nextProps.sensors.alarmStatusByGroup !== prevState.alarmStatusByGroup) {
      state.alarmStatusByGroup = nextProps.sensors.alarmStatusByGroup;
    }
    if (nextProps.maps.loading !== prevState.loading) {
      state.loading = nextProps.maps.loading;
    }
    state.errors = helper.centralizeError([
      nextProps.maps.errors,
      nextProps.sensors.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    const { mapName, mapDepartmentId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    await this.props.mapsActions.getMapImage(mapDepartmentId, mapName);
    await this.props.mapsActions.getMapShapes(mapDepartmentId, mapName);
    this.setState({
      didMount: true,
      lastUpdated: getCurrentTime(),
      deptId: mapDepartmentId,
      mapName: mapName,
    });
  }
  async componentDidUpdate(prevProps, prevState) {
    if (this.state.didMount && this.state.didMount !== prevState.didMount) {
      const sensorIds = [];
      const groupIds = [];
      this.state.mapShapes.shapes.forEach((shape) => {
        const { className } = shape;
        if (className === 'Multi' || className === 'CircleShape') {
          if (shape.sensorId) {
            sensorIds.push(shape.sensorId);
          }
        }
        if (className === 'SquareShape') {
          if (shape.groupId) {
            groupIds.push(shape.groupId);
          }
        }
      });
      if (groupIds.length) {
        await this.props.sensorsActions.getAlarmStatusByGroup(
          groupIds.join(','),
        );
      }
      if (sensorIds.length) {
        await this.props.sensorsActions.getAlarmStatus(sensorIds.join(','));
      }
      const intervalId = setInterval(async () => {
        if (sensorIds.length) {
          await this.props.sensorsActions.getAlarmStatus(sensorIds.join(','));
        }
        if (groupIds.length) {
          await this.props.sensorsActions.getAlarmStatusByGroup(
            groupIds.join(','),
          );
        }
        this.setState({ lastUpdated: getCurrentTime() });
      }, parseInt(this.refreshRate.value) * 1000);
      this.setState({ intervalId, lastUpdated: getCurrentTime() });
    }
  }
  componentWillUnmount() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
      this.setState({ intervalId: null });
    }
    const diff = moment().diff(this.timeStart, 'minutes');
    if (diff > parseFloat(this.timeOutMin)) {
      this.props.history.push('/login');
    }
  }
  render() {
    const { loading, isInvalid } = this.state;
    const { mapGroupId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    if (isInvalid) {
      return <Unprivileged />;
    }
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <MapViewerPage
        {...this.state}
        refreshRate={parseInt(this.refreshRate.value) * 1000}
        history={this.props.history}
        mapGroupId={mapGroupId}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    maps: state.maps,
    sensors: state.sensors,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    mapsActions: bindActionCreators(Object.assign({}, mapsActions), dispatch),
    sensorsActions: bindActionCreators(
      Object.assign({}, sensorsActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(GroupMap);
